module.exports = __webpack_public_path__ + "static/media/menu-delivery.d0ecc328.svg";